<script lang="ts" context="module">
    import Modal, { createModal } from '$components/Modal.svelte';

    export { createModal };
</script>

<script lang="ts">
    import type { ParticipantInput } from '$gql/graphql.js';
    import FeedPostForm from './FeedPostForm.svelte';
    import { melt } from '@melt-ui/svelte';

    export let initialAuthor: ParticipantInput;
    export let title: string;
    export let sharedPostId: number | null = null;
    export let relatedCategoryId: number | null = null;
    export let country: string | null = null;
    export let modal: ReturnType<typeof createModal>;
    export let onSuccess: (() => void) | null = null;
    export let initialBody: string = '';

    const {
        elements: { title: titleElement, close },
    } = modal;
</script>

<Modal contentClass="max-w-[600px]" dialogClass="p-0 items-start" {modal}>
    <div class="p-5 border-0 text-left">
        <button use:melt={$close} class="close">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 use:melt={$titleElement} class="modal-title m-0 text-18 ls:text-22">
            {title}
        </h4>
    </div>

    <div class="text-left">
        <FeedPostForm
            autoFocus
            {sharedPostId}
            {relatedCategoryId}
            {initialAuthor}
            on:success={() => {
                modal.states.open.set(false);
                onSuccess?.();
            }}
            {country}
            {initialBody}
        />
    </div>
</Modal>
